import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import EmployerCarousel from "../Home/EmployerCarousel";
import MultipleItems from "./CarouselTest";
import TestimonialsCarousel from "../Home/TestimonialsCarousel";



export default function EmployerZone() {
    const [content, setContent] = useState([]);
    const [pricing, setPricing] = useState([]);

   
    const [organizationData, setOrganizationData] = useState([]);
    const [activeTab, setActiveTab] = useState("");

  useEffect(() => {
      let isMounted = true;
      const controller = new AbortController();
  
      axios
        .get("api/home/get_organization_data", { signal: controller.signal })
        .then((res) => {
          if (!isMounted) return;
          if (res.data.status == "success") {
            setOrganizationData(res.data.data);
          } else {
            setOrganizationData([]);
          }
        })
        .catch((error) => {
          if (!isMounted) return;
          if (error.name !== "AbortError" && error.name !== "CanceledError") {
            console.error("Failed to load organization data:", error);
          }
        });
  
      window.scrollTo(0, 0);
  
      return () => {
        isMounted = false;
        controller.abort();
      };
    }, []);
  
  const [isScrollVisible, setIsScrollVisible] = useState(false);



  useEffect(() => {
    const onScroll = () => setIsScrollVisible(window.scrollY > 300);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  
   useEffect(() => {
      let isMounted = true;
      const controller = new AbortController();
  
      window.scrollTo(0, 0);
      axios.get("/api/home/get_services", { signal: controller.signal }).then((res) => {
        if (!isMounted) return; //Guard skip state if unmounted
        if (res.data.status == "success") {
          setContent(res.data.content);
        } else {
          setContent([]);
        }
      }).catch(error => {
        if (!isMounted) return;
        if (error.name !== "AbortError"  && error.name !== "CanceledError") {
          console.error("Failed to load about us:", error);
        }
      });
  
      // Cleanup: cancel request if component unmounts
      return () => {
        isMounted = false;
        controller.abort();
      };
    }, []);

   useEffect(() => {
      let isMounted = true;
      const controller = new AbortController();
  
      window.scrollTo(0, 0);
      axios.get("/api/home/get_pricing", { signal: controller.signal }).then((res) => {
        if (!isMounted) return; //Guard skip state if unmounted
        if (res.data.status == "success") {
          setPricing(res.data.pricing);
        } else {
          setPricing([]);
        }
      }).catch(error => {
        if (!isMounted) return;
        if (error.name !== "AbortError"  && error.name !== "CanceledError") {
          console.error("Failed to load pricing:", error);
        }
      });
  
      // Cleanup: cancel request if component unmounts
      return () => {
        isMounted = false;
        controller.abort();
      };
    }, []);

  const scrollToTop = () => window.scrollTo({ top: 0, behavior: "smooth" });



    const handleTabClick = (e, targetId) => {
    e.preventDefault();
    setActiveTab(targetId);
    const element = document.getElementById(targetId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <React.Fragment>
      <section className="employer_zone">
        <div className="container">
          <div className="emp_zone_top">
            <h1 className="emp-zone-title">
              Employer Zone.
            </h1>
            <p className="emp-zone-subtitle">
              Start your hiring journey with us! Create a free recruiter account or log in to post jobs, manage applications, and find the perfect candidates for your team.
            </p>
            <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="0.6" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-building2 lucide-building-2 text-primary" aria-hidden="true"><path d="M10 12h4"></path><path d="M10 8h4"></path><path d="M14 21v-3a2 2 0 0 0-4 0v3"></path><path d="M6 10H4a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-2"></path><path d="M6 21V5a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v16"></path></svg>
            <div className="flex justify-center items-center w-full max-w-lg btn-zone-sec">
               <Link to={"/login-employer"} className="text-white py-2 flex-1 bg-secondary rounded">
                  <i className="ri-briefcase-line"></i> Login
                </Link>
                <Link to={"/register-employer"} className="text-white py-2 flex-1 bg-primary rounded">
                  <i className="ri-login-box-line"></i> Sign Up
                </Link>
            </div>
            <p className="emp-zone-link">
              Already have an account ?<Link to={"/login-employer"} className="twm-login"> Login</Link>
            </p>
          </div>
        </div>
      </section>

{/* ── In-Page Local Tab Navigation ────────────────── */}
      <div className="sf-local-tabs-container">
        <div className="sf-container sf-local-tabs">
          <a 
            href="#our-services" 
            className={`sf-tab-item ${activeTab === "our-services" ? "active" : ""}`}
            onClick={(e) => handleTabClick(e, "our-services")}
          >
            Our Services
          </a>
          <a 
            href="#plans-and-pricing" 
            className={`sf-tab-item ${activeTab === "plans-and-pricing" ? "active" : ""}`}
            onClick={(e) => handleTabClick(e, "plans-and-pricing")}
          >
            Plans and Pricing

          </a>
          <a 
            href="#trusted-partner" 
            className={`sf-tab-item ${activeTab === "trusted-partner" ? "active" : ""}`}
            onClick={(e) => handleTabClick(e, "trusted-partner")} >
            Trusted Partner
          </a>
        </div>
      </div>

    <section id="our-services" className="bg-white">
      <div className="sf-container">
        <h1 className="sf-testimonials-title">
          Services We Provide
        </h1>
         <div className="row">
                  {content.length > 0
                    ? content.map((item, idx) => {
                        let colorName = ["sky", "yellow", "pink", "green"];
                        let titleWords = item.title.split(" ");
                        let firstWord = titleWords[0];
                        let remWords = titleWords.slice(1).join(" ");
                        return (
                          <div className="col-xl-4 col-lg-4 col-md-4">
                            <div className="twm-w-process-steps-2">
                              <div
                                className={`twm-w-pro-top bg-clr-${colorName[idx]}-light bg-${colorName[idx]}-light-shadow`}
                              >
                                <span
                                  className={`twm-large-number text-clr-${colorName[idx]}`}
                                >
                                  0{idx + 1}
                                </span>
                                {/* <div className="twm-media">
                                  <span>
                                    <img src={item.imgUrl} alt={item.title} />
                                  </span>
                                </div> */}
                                <h4 className="twm-title">
                                  {firstWord}
                                  <br />
                                  {remWords}
                                </h4>
                                <p>{item.content}</p>
                              </div>
                            </div>
                          </div>
                        );
                      })
                    : ""}
                </div>
        </div>       
    </section>

    <section id="plans-and-pricing" className="bg-white">
        <div className="sf-container">
        <h1 className="sf-testimonials-title">
          Plans and Pricing
        </h1>
            <div className="row">
                  {pricing.length > 0
                    ? pricing.map((item, idx) => {
                        let colorName = ["sky", "yellow", "pink", "green"];
                        let titleWords = item.title.split(" ");
                        let firstWord = titleWords[0];
                        let remWords = titleWords.slice(1).join(" ");
                        return (
                          <div className="col-xl-4 col-lg-4 col-md-4">
                            <div className="twm-w-process-steps-2">
                              <div
                                className={`twm-w-pro-top bg-clr-${colorName[idx]}-light bg-${colorName[idx]}-light-shadow`}
                              >
                                <span
                                  className={`twm-large-number text-clr-${colorName[idx]}`}
                                >
                                  0{idx + 1}
                                </span>
                                {/* <div className="twm-media">
                                  <span>
                                    <img src={item.imgUrl} alt={item.title} />
                                  </span>
                                </div> */}
                                <h4 className="twm-title">
                                  {firstWord}
                                  <br />
                                  {remWords}
                                </h4>
                                <p>{item.content}</p>
                              </div>
                            </div>
                          </div>
                        );
                      })
                    : ""}
          </div>
        </div>   
    </section>

    <TestimonialsCarousel />
    {/* <section className="sf-section sf-section-light">
      <div className="sf-container">
<MultipleItems />
</div>
</section> */}
    {/* ── Actively Recruiting Employers ────────── */}
      <EmployerCarousel />

        <section>
             {/* ── Map ── */}
                <div className="sf-cp-map-wrap">

                <iframe src={organizationData.google_map_code}
                height="420"  
                allowFullScreen="" 
                loading="lazy" 
                referrerPolicy="no-referrer-when-downgrade">
                </iframe>

                </div>       
        </section>




      {/* ── Scroll-to-top ────────────────────────── */}
      {isScrollVisible && (
        <button
          className="sf-scroll-top"
          onClick={scrollToTop}
          aria-label="Scroll to top"
        >
          <i className="fa fa-angle-up" />
        </button>
      )}
    </React.Fragment>
  );
}
